const BLOCKED = new Set(["__proto__", "prototype", "constructor"]);

export function getPath(obj: unknown, path: string): unknown {
  let cur: unknown = obj;
  for (const key of path.split(".")) {
    if (cur === null || cur === undefined || typeof cur !== "object")
      return undefined;
    if (BLOCKED.has(key) || !Object.hasOwn(cur, key)) return undefined;
    cur = (cur as Record<string, unknown>)[key];
  }
  return cur;
}

const VAR = /\{\{\s*([\w.]+)\s*\}\}/g;

/** Missing or non-scalar variables render as "" and are reported (spec 05 §4). */
export function renderTemplate(
  tpl: string,
  ctx: unknown,
): { text: string; missing: string[] } {
  const missing: string[] = [];
  const text = tpl.replace(VAR, (_m, path: string) => {
    const v = getPath(ctx, path);
    if (v === null || v === undefined) {
      if (!missing.includes(path)) missing.push(path);
      return "";
    }
    if (
      typeof v === "string" ||
      typeof v === "number" ||
      typeof v === "boolean"
    )
      return String(v);
    return "";
  });
  return { text, missing };
}
